













export enum DirectionType {
  row,
  column,
}

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    emphasizeLabel: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: String,
      default: null,
    },
    direction: {
      type: Number,
      default: DirectionType.column,
    },
  },
  computed: {
    directionClass(): string {
      return this.direction === DirectionType.column ? 'column' : 'row'
    },
  },
}
